<template>
    <div :class="preCls + 'content-box'">
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            >
            </filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入客户姓名、手机号"
                    style="margin-left: 10px"
                    @search="search"
                >
                </table-searcher>
            </template>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- 余额 -->
            <template v-slot:weBalance="{ row }">
                <span
                    :style="{
                        color: parseFloat(row.weBalance) < 0 ? 'red' : '',
                    }"
                >
                    {{ row.weBalance }}
                </span>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <PoptipButton
                    v-if="$can('update') && !row.prepaid"
                    transfer
                    type="default"
                    style="margin-right: 5px"
                    title="您确定开通吗？"
                    text="开通预付"
                    :ok="() => onPrepaidClick(row.houseId)"
                ></PoptipButton>
                <PoptipButton
                    v-if="$can('update') && row.prepaid === 1"
                    transfer
                    type="default"
                    style="margin-right: 5px"
                    title="您确定关闭吗？"
                    text="关闭预付"
                    :ok="() => onPrepaidClick(row.houseId)"
                ></PoptipButton>
                <Button
                    v-if="$can('update') && row.prepaid === 1"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRechargeClick(row)"
                >
                    手工充值
                </Button>
                <Dropdown
                    transfer
                    @on-click="
                        (name) => {
                            changeAction(name, row)
                        }
                    "
                >
                    <Button v-if="$can('view')" type="default" size="small">
                        更多
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="lookweflow">
                            查看流水
                        </DropdownItem>
                        <DropdownItem name="history"> 充值记录 </DropdownItem>
                        <DropdownItem name="deduction"> 扣费记录 </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        >
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showRechargeForm"
            title="手工充值"
            :width="600"
            :height="350"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <order-recharge-form
                v-if="modal.showRechargeForm"
                :houseId="houseId"
                :houseName="houseName"
                :cusId="cusId"
                :cusName="cusName"
                :cusMobile="cusMobile"
            >
            </order-recharge-form>
        </smart-modal>
        <smart-modal
            v-model="modal.showHistoryList"
            title="充值记录"
            :width="1000"
            :height="600"
            :maskClosable="false"
        >
            <order-recharge-history
                v-if="modal.showHistoryList"
                :houseId="houseId"
                :houseName="houseName"
                :cusId="cusId"
                :cusName="cusName"
                :cusMobile="cusMobile"
            >
            </order-recharge-history>
        </smart-modal>
        <smart-modal
            v-model="modal.showDeductionList"
            title="扣费记录"
            :width="1000"
            :height="600"
            :maskClosable="false"
        >
            <order-deduction-list
                v-if="modal.showDeductionList"
                :houseId="houseId"
                :houseName="houseName"
                :cusId="cusId"
                :cusName="cusName"
                :cusMobile="cusMobile"
            >
            </order-deduction-list>
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import { currency, ymdL } from '_u/helper'

import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import FilterDateRange from '_v/components/filter/filter-date-range'
import OrderRechargeForm from './order-recharge-form'
import OrderRechargeHistory from './order-recharge-history'
import OrderDeductionList from './order-deduction-list'

import { orderRechargeList, orderRechargePrepaid } from '@/api/order'

export default {
    name: 'order-recharge-list',
    mixins: [mList],
    components: {
        SelectRoom,
        FilterDateRange,
        OrderRechargeHistory,
        OrderDeductionList,
        OrderRechargeForm,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            houseId: '',
            houseName: '',
            cusId: '',
            cusName: '',
            cusMobile: '',
            modal: {
                showRechargeForm: false,
                showHistoryList: false,
                showDeductionList: false,
            },
        }
    },
    computed: {
        ...mapCache({
            filter: 'rechargeFilter',
            selectRoom: 'rechargeSelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60,
                },
                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: 'weBalance',
                    title: '账户余额(元)',
                    align: 'right',
                    minWidth: 150,
                    slot: 'weBalance',
                },
                {
                    key: 'waterReading',
                    title: '当前水表读数(吨)',
                    align: 'right',
                    minWidth: 150,
                },
                {
                    key: 'electricReading',
                    title: '当前电表读数(度)',
                    align: 'right',
                    minWidth: 150,
                },
                {
                    key: 'hotReading',
                    title: '当前热水表读数(吨)',
                    align: 'right',
                    minWidth: 150,
                },
                {
                    key: 'payTime',
                    title: '最近充值时间',
                    align: 'center',
                    minWidth: 180,
                    render: pipeCell('ymdL'),
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 220,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([orderRechargeList(this.filter)])
                .then((args) => {
                    var [view] = args

                    if (view.data.page) {
                        view.data.page.list.forEach((v) => {
                            v.weBalance = currency(v.weBalance / 100)
                            v.arrears = currency(v.arrears / 100)
                            v.waterReading =
                                v.waterReading === null
                                    ? ''
                                    : currency(v.waterReading || 0)
                            v.hotReading =
                                v.hotReading === null
                                    ? ''
                                    : currency(v.hotReading || 0)
                            v.electricReading =
                                v.electricReading === null
                                    ? ''
                                    : currency(v.electricReading || 0)
                        })
                        this.setPageData(view.data)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onPrepaidClick(id) {
            orderRechargePrepaid(id).then((res) => {
                this.$Message.success(this.$t('tips.update.success'))
                this.search()
            })
        },

        onRechargeClick(row) {
            this.houseId = row.houseId
            this.houseName = row.houseName
            this.cusId = row.cusId
            this.cusName = row.cusName
            this.cusMobile = row.cusMobile
            this.modal.showRechargeForm = true
        },

        changeAction(name, row) {
            this[name](row)
        },

        history(row) {
            this.houseId = row.houseId
            this.houseName = row.houseName
            this.cusId = row.cusId
            this.cusName = row.cusName
            this.cusMobile = row.cusMobile
            this.modal.showHistoryList = true
        },

        lookweflow(row) {
            // 查看流水
            this.$router.push({
                name: 'orderRechaargeWeflow',
                query: { houseIds: row.houseId, houseName: row.houseName },
            })
        },

        deduction(row) {
            this.houseId = row.houseId
            this.houseName = row.houseName
            this.cusId = row.cusId
            this.cusName = row.cusName
            this.cusMobile = row.cusMobile
            this.modal.showDeductionList = true
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
}
</script>
<style lang="less" scoped></style>
